import { EASING } from "./easingUtils";

export const variants = (x = 1000, opacity = 0) => ({
  enter: {
    x: x,
    opacity,
    transition: { duration: 0.3, ease: EASING.easeOut },
  },
  center: {
    x: 0,
    opacity: 1,
    transition: { duration: 0.3, ease: EASING.easeInOut },
  },
  exit: {
    x: -x,
    opacity,
    transition: { duration: 0.3, ease: EASING.easeIn },
  },
});

// For direction-based variants, provide separate variants
export const directionVariants = (x = 1000, opacity = 0) => ({
  enterRight: {
    x: x,
    opacity,
    transition: { duration: 0.3, ease: EASING.easeOut },
  },
  enterLeft: {
    x: -x,
    opacity,
    transition: { duration: 0.3, ease: EASING.easeOut },
  },
  center: {
    x: 0,
    opacity: 1,
    transition: { duration: 0.3, ease: EASING.easeInOut },
  },
  exitRight: {
    x: x,
    opacity,
    transition: { duration: 0.3, ease: EASING.easeIn },
  },
  exitLeft: {
    x: -x,
    opacity,
    transition: { duration: 0.3, ease: EASING.easeIn },
  },
});
